import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Banner = ({ title, subtitle, imageUrls = [] }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageUrls?.length);
    }, 3000); // Change image every 3 seconds
    return () => clearInterval(timer);
  }, [imageUrls?.length]);

  const goPrevious = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? imageUrls?.length - 1 : prevIndex - 1
    );
  };

  const goNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageUrls?.length);
  };

  return (
    <Box
      sx={{
        height: 400,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        backgroundImage: `url(${imageUrls[currentImageIndex]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        textAlign: "center",
        p: 3,
        marginTop: 2,
      }}
    >
      <IconButton
        onClick={goPrevious}
        sx={{ position: "absolute", left: 8, top: "50%", zIndex: 2 }}
      >
        <ArrowBackIosNewIcon fontSize="large" />
      </IconButton>
      <IconButton
        onClick={goNext}
        sx={{ position: "absolute", right: 8, top: "50%", zIndex: 2 }}
      >
        <ArrowForwardIosIcon fontSize="large" />
      </IconButton>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Typography variant="h2" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h6" gutterBottom>
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default Banner;
